import {BlocksPanelApi} from '../api/BlocksPanelApi';

export interface BlockItem {
  name: string;
  title: string;
  iconSrc: string;
  description: string;
  disabled?: boolean;
}

export interface BlockHint {
  title: string;
  description: string;
}

export class BlocksPanel {
  api!: BlocksPanelApi;

    /**
     * Generates HTML representation for a block item
     * @param block - The block item to generate HTML for
     * @returns HTML string representation of the block or undefined if default representation should be used
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getBlockItemHtml(block: BlockItem): string | undefined {
    return undefined;
  }

    /**
     * Determines whether a hint should be displayed for the block
     * @param block - The block item to check hint visibility for
     * @returns True if the hint should be visible, false otherwise
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public isBlockHintVisible(block: BlockItem): boolean {
    return true;
  }

  /**
   * Determines whether a draggable handle should be displayed in modules panel
   * @returns True if the block panel should be reorderable
   */
  public isPanelPlacementChangeEnabled(): boolean {
    return true;
  }

    /**
     * Gets the hint text for a block
     * @param block - The block item to get hint for
     * @returns The hint text for the block or undefined if default hint should be used
     */
  public getBlockHint(block: BlockItem): BlockHint | undefined {
    return {
      title: block.title,
      description: block.description,
    };
  }

    /**
     * Generates HTML representation for the blocks panel header
     * @returns HTML string representation of the blocks panel header or undefined if header should not be shown
     */
  public getBlocksPanelHeaderHtml(): string | undefined {
    return undefined;
  }

    /**
     * Generates HTML representation for the modules panel in collapsed state
     * @returns HTML string representation of the collapsed modules panel or undefined if default representation should be used
     */
  public getModulesPanelCollapsedHtml(): string | undefined {
    return undefined;
  }

    /**
     * Determines whether a hint should be displayed for the collapsed modules panel
     * @returns True if the hint should be visible, false otherwise
     */
  public isModulesPanelCollapsedHintVisible(): boolean {
    return true;
  }

    /**
     * Gets the custom delay for showing hints
     * @returns The delay in milliseconds or undefined to use the default delay
     */
  public getHintDelay(): number | undefined {
    return undefined;
  }

    /**
     * Gets the hint text for a modules panel block
     * @returns The hint text for the modules panel or undefined if default hint should be used
     */
  public getModulesPanelHint(): BlockHint | undefined {
    return undefined;
  }

    /**
     * Gets the icon name for the modules tab
     * @returns The icon name for the modules tab or undefined if default icon or text should be used
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public getModulesTabIconName(modulesTab: {key: string; label: Record<string, string>}): string | undefined {
    return undefined;
  }
}
